
module.exports = {
    // "alternateAddress": "550 W FULTON ST",
    "streets": {
        "FOREST PARK BLVD": {
            "addresses": {
                "FOREST PARK BLVD": {
                    "address": "FOREST PARK BLVD",
                    "count": "1",
                    "display_address": "1",
                    "expectedCount": "0",
                    "max": "1115",
                    "melissaCount": "0",
                    "min": "1115",
                    "sort_house": "1115",
                    "sort_street": "FOREST PARK BLVD~^~FORT WORTH~^~76110",
                    "zip_code": "76110"
                }
            },
            // "individualAddresses": [
            //     {
            //         "name": "111 abc",
            //         "selected": true
            //     },
            //     {
            //         "name": "112 abc",
            //         "selected": false
            //     }
            // ]
        },
        "IRWIN ST": {
            "addresses": {
                "IRWIN ST": {
                    "address": "IRWIN ST",
                    "count": "15",
                    "display_address": "1",
                    "expectedCount": "0",
                    "max": "2313",
                    "melissaCount": "0",
                    "min": "2225",
                    "sort_house": "2225",
                    "sort_street": "IRWIN ST~^~FORT WORTH~^~76110",
                    "zip_code": "76110"
                }
            }
        },
        "MISTLETOE BLVD": {
            "addresses": {
                "MISTLETOE BLVD": {
                    "address": "MISTLETOE BLVD",
                    "count": "5",
                    "display_address": "1",
                    "expectedCount": "0",
                    "max": "2308",
                    "melissaCount": "0",
                    "min": "2232",
                    "sort_house": "2232",
                    "sort_street": "MISTLETOE BLVD~^~FORT WORTH~^~76110",
                    "zip_code": "76110"
                }
            }
        },
        "W ROSEDALE ST S": {
            "addresses": {
                "W ROSEDALE ST S": {
                    "address": "W ROSEDALE ST S",
                    "count": "4",
                    "display_address": "1",
                    "expectedCount": "0",
                    "max": "2301",
                    "melissaCount": "0",
                    "min": "2237",
                    "sort_house": "2237",
                    "sort_street": "W ROSEDALE ST S~^~FORT WORTH~^~76110",
                    "zip_code": "76110"
                }
            }
        }
    }
};